import React from "react";
import { makeStyles, ThemeProvider } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Badge from "@material-ui/core/Badge";
import PropTypes from "prop-types";
import MenuItem from "@material-ui/core/MenuItem";
import { createMuiTheme } from "@material-ui/core/styles";
import Menu from "@material-ui/core/Menu";
import { css } from "react-emotion";
import AccountCircle from "@material-ui/icons/AccountCircle";
import MailIcon from "@material-ui/icons/Mail";
import NotificationsIcon from "@material-ui/icons/Notifications";
import MoreIcon from "@material-ui/icons/MoreVert";
import { Profile, JoyRide } from "components";
import { withRedux, dig } from "helpers";
import { Link } from "react-router-dom";

const linkStyle = css`
  max-height: 4em;
  margin-left: 2em;
  cursor: pointer;
`;
const mobileLogo = css`
  display: none;

  @media only screen and (max-width: 767px) {
    display: block !important;
    width: 40px;
    height: 30px;
    object-fit: contain;
  }
`;
const responsiveLogo = css`
  width: 300px;
  height: 45px;
  object-fit: contain;
  margin-left: -90px;
  @media only screen and (max-width: 767px) {
    display: none;
  }
`;

const appNameStyles = css`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 2em;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #1f3747;
  display: inline-block;
  text-align: center;
  @media only screen and (max-width: 767px) {
    font-size: 1.5em;
    font-weight: normal;
  }
`;

const theme = createMuiTheme({
  overrides: {
    MuiToolbar: {
      regular: {
        display: "flex",
        justifyContent: "space-between",
        minHeight: "80px",
        "@media(min-width:600px)": {
          minHeight: "90px",
        },
        "@media (min-width: 0px) and (orientation: landscape)": {
          minHeight: "100px",
        },
      },
    },
  },
});

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  welcomeMessage: {
    fontSize: "14px",
    fontWeight: "normal",
    fontStyle: "normal",
    fontStretch: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "#89d2d3",
    display: "inline-block",
    textAlign: "center",
  },
  logoutText: {
    fontSize: "14px",
    fontWeight: "normal",
    fontStyle: "normal",
    fontStretch: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "#1f3747",
    display: "inline-block",
    textAlign: "center",
  },

  sectionDesktop: {
    display: "none",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
}));

function NewNavBar(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const firstName = dig(props, "platformInfo", "status", "user", "firstName");
  const lastName = dig(props, "platformInfo", "status", "user", "lastName");
  const appName = dig(props, "activeApp", "name");
  const isLobby = props.location.pathname === "/lobby";

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = "primary-search-account-menu";
  const logOut = () => {
    props.actions.resetDisplay();
    props.actions.resetApplications();
    props.actions.logOut();
  };
  const goToOrders = () => {
    if (props.activeApp) {
      // console.log("there is an active app selected");
    }
  };
  const renderMenu = () => {
    let user = props.platformInfo.status.user;

    if (!user) return <div />;
    return (
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        id={menuId}
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={isMenuOpen}
        onClose={handleMenuClose}
        style={{ top: "45px" }}
      >
        {/* <MenuItem onClick={handleMenuClose}>Profile</MenuItem> */}
        <MenuItem onClick={logOut} className={classes.logoutText}>
          Log Out
        </MenuItem>
      </Menu>
    );
  };

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = () => {
    let user = props.platformInfo.status.user;

    if (!user) return <div />;
    return (
      <Menu
        anchorEl={mobileMoreAnchorEl}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        id={mobileMenuId}
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={isMobileMenuOpen}
        onClose={handleMobileMenuClose}
        style={{ top: "35px" }}
      >
        {/* <MenuItem>
        <IconButton aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={4} color="secondary">
            <MailIcon />
          </Badge>
        </IconButton>
        <p>Messages</p>
      </MenuItem>
      <MenuItem>
        <IconButton aria-label="show 11 new notifications" color="inherit">
          <Badge badgeContent={11} color="secondary">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem> */}
        <MenuItem onClick={logOut}>
          <IconButton
            aria-label="account of current user"
            aria-controls="primary-search-account-menu"
            aria-haspopup="true"
            color="inherit"
          >
            <AccountCircle style={{ color: "#89D2D3" }} />
          </IconButton>
          <p className={classes.logoutText}>Log Out</p>
        </MenuItem>
      </Menu>
    );
  };

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.grow}>
        <AppBar
          position="static"
          style={{
            background: "white",
            color: "#89D2D3",
            marginBottom: "10px",
          }}
        >
          <Toolbar>
            {/* <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="open drawer"
          >
            <MenuIcon />
          </IconButton> */}
            <Link className={linkStyle} to="/lobby">
              <img
                className={mobileLogo}
                src="https://mobile360-assets.s3.us-east-2.amazonaws.com/logo/just_logo.png"
                alt="mobileLogo"
              />

              <img
                src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/logo_small.png"
                className={responsiveLogo}
                alt="responsiveLogo"
              />
            </Link>
            {!isLobby && <h2 className={appNameStyles}>{appName}</h2>}

            <div className={classes.sectionDesktop}>
              <JoyRide />
              {firstName && lastName ? (
                <Typography
                  className={classes.welcomeMessage}
                  variant="h6"
                  noWrap
                >
                  Welcome back, {firstName}
                </Typography>
              ) : null}
              {/* <IconButton aria-label="show 4 new mails" color="inherit">
                <Badge badgeContent={4} color="secondary">
                  <MailIcon />
                </Badge>
              </IconButton>
              <IconButton
                aria-label="show 17 new notifications"
                color="inherit"
              >
                <Badge badgeContent={17} color="secondary">
                  <NotificationsIcon />
                </Badge>
              </IconButton> */}
              <IconButton
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
            </div>
            <div className={classes.sectionMobile}>
              <IconButton
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
              >
                <MoreIcon />
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>{" "}
        {renderMobileMenu()}
        {renderMenu()}
      </div>
    </ThemeProvider>
  );
}

export default withRedux(NewNavBar);
